import ModalV2 from "../ModalV2";
import { ArrowRightIcon, MailIcon, Shield } from "lucide-react";
import { useState } from "react";
import useModal from "../../hooks/useModal";
import { Button } from "@oc-labs/wt-storybook";
import useCompany from "../../hooks/useCompany";
import toast from "react-hot-toast";
import PropTypes from "prop-types";

export default function InviteAdminModal({ onInviteSuccess }) {
  const [email, setEmail] = useState('');
  const { inviteMember } = useCompany();
  const { close } = useModal('invite-admin');

  return (<ModalV2 name={'invite-admin'} className="!p-0 w-[750px]">
      <div className="w-full overflow-hidden flex flex-col md:flex-row animate-in fade-in zoom-in duration-300">
        <div className="md:w-1/3 bg-gradient-to-br from-blue-600 to-indigo-700 p-8 flex flex-col justify-center items-center text-white relative">
          <div className="absolute inset-0 opacity-10 pointer-events-none overflow-hidden">
            <svg className="w-full h-full" preserveAspectRatio="none" viewBox="0 0 100 100">
              <circle cx="10" cy="10" fill="currentColor" r="30"></circle>
              <circle cx="90" cy="90" fill="currentColor" r="40"></circle>
            </svg>
          </div>
          <div className="relative z-10 text-center">
            <div className="w-16 h-16 bg-white/20 backdrop-blur-md rounded-2xl flex items-center justify-center mb-6 mx-auto">
              <MailIcon className="w-8 h-8 text-white" />
            </div>
            <h3 className="text-xl font-bold mb-2">Build Together</h3>
            <p className="text-blue-100 text-sm leading-relaxed">Expand your team and manage roles effortlessly.</p>
          </div>
        </div>
        <div className="md:w-2/3 p-8 md:p-12 bg-white">
          <div className="mb-8">
            <h2 className="text-2xl font-bold text-slate-900">Invite a new admin</h2>
            <p className="text-slate-500 mt-2">Enter the email address of the person you want to grant administrative access to your dashboard.</p>
          </div>
          <div className="space-y-6">
            <div className="relative floating-label-input">
              <input 
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter email address"
              className="block w-full px-4 py-3 bg-slate-50 border border-slate-200 rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent outline-none transition-all" id="email" type="email" />
              
            </div>
            <div className="flex items-center gap-4 pt-2">
              <Button type="tertiary" onClick={close}>
                Cancel
              </Button>
              <Button type="primary" onClick={async () => {
                const result = await inviteMember(email);
                if (result?.error) {
                  toast.error(result.error.message || "Failed to invite member");
                } else if (result) {
                  toast.success("Invite sent successfully");
                  if (onInviteSuccess) {
                    onInviteSuccess();
                  }
                  close();
                }
              }}>
                <span>Send Invite</span>
                <ArrowRightIcon className="w-5 h-5" />
              </Button>
            </div>
          </div>
          <div className="mt-8 flex items-center gap-2 text-xs text-slate-400">
            <Shield className="w-4 h-4" />
            <span>They will receive a secure link to join your organization.</span>
          </div>
        </div>
      </div>
  </ModalV2>)
}

InviteAdminModal.propTypes = {
  onInviteSuccess: PropTypes.func,
};